/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivAppraisalResponseControllerAcceptParamsGen,
  MrfiktivAppraisalResponseControllerGetParamsGen,
  MrfiktivAppraisalResponseControllerRejectParamsGen,
  MrfiktivAppraisalResponseDtoGen,
  MrfiktivAppraisalViewModelGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AppraisalRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags appraisal-request
   * @name AppraisalResponseControllerGet
   * @summary (SCT) Get an appraisal
   * @request GET:/partner/{partnerId}/appraisal/{appraisalId}/request
   * @secure
   * @response `200` `MrfiktivAppraisalViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Appraisal not found.
   */
  appraisalResponseControllerGet = (
    { partnerId, appraisalId, ...query }: MrfiktivAppraisalResponseControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivAppraisalViewModelGen, void>({
      path: `/partner/${partnerId}/appraisal/${appraisalId}/request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal-request
   * @name AppraisalResponseControllerAccept
   * @summary (sct) Accepts an appraisal request
   * @request PATCH:/partner/{partnerId}/appraisal/{appraisalId}/request/accept
   * @secure
   * @response `201` `MrfiktivAppraisalViewModelGen` The updated appraisal
   */
  appraisalResponseControllerAccept = (
    { partnerId, appraisalId, ...query }: MrfiktivAppraisalResponseControllerAcceptParamsGen,
    data: MrfiktivAppraisalResponseDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partner/${partnerId}/appraisal/${appraisalId}/request/accept`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal-request
   * @name AppraisalResponseControllerReject
   * @summary (sct) Rejects an appraisal request
   * @request PATCH:/partner/{partnerId}/appraisal/{appraisalId}/request/reject
   * @secure
   * @response `201` `MrfiktivAppraisalViewModelGen` The updated appraisal
   */
  appraisalResponseControllerReject = (
    { partnerId, appraisalId, ...query }: MrfiktivAppraisalResponseControllerRejectParamsGen,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partner/${partnerId}/appraisal/${appraisalId}/request/reject`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
